import { datadogRum } from '@datadog/browser-rum';
import * as Sentry from '@sentry/react';

export const setUser = (userUuid: string): void => {
  // Call DD first because setUser is Async
  datadogRum.setUser({ id: userUuid });
  Sentry.setUser({ id: userUuid });
  return;
};
